var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgChevronRight = function SvgChevronRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 9 18"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 .33c.19 0 .38.07.53.22l6.52 6.52a2.74 2.74 0 0 1 0 3.86l-6.52 6.52c-.29.29-.77.29-1.06 0a.754.754 0 0 1 0-1.06l6.52-6.52c.48-.48.48-1.26 0-1.74L.47 1.61a.754.754 0 0 1 0-1.06C.62.41.81.33 1 .33Z"
  })));
};
export default SvgChevronRight;